import state from "./moduleAppLogoState.js";
import mutations from "./moduleAppLogoMutations.js";
import actions from "./moduleAppLogoActions.js";
import getters from "./moduleAppLogoGetters.js";

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  isRegistered: false,
};
